/**
 * Бизнес-логика сущности "Заявка на диагностику".
 *
 * statusMap — маппинг статусов на лейблы и цвета бейджей.
 * Применяется: Ros, Workshop, Master, Mechanic
 *
 * getOrderStatus — возвращает итоговый статус заявки с учётом outcome и is_sent.
 * Применяется: Ros, Workshop
 *
 */

export const statusMap = {
    open: { label: 'Новая', bg: '#F3F4F6', color: '#6B7280' },
    in_progress: { label: 'В работе', bg: '#FEF3C7', color: '#D97706' },
    closed: { label: 'Завершена', bg: '#D1FAE5', color: '#059669' },
    expired_open: { label: 'Пропущена', bg: '#FEE2E2', color: '#DC2626' },
    expired_progress: { label: 'Брошена', bg: '#FEE2E2', color: '#DC2626' },
    sent: { label: 'Отправлена', bg: '#DBEAFE', color: '#1E3A8A' },
}

export function getOrderStatus(order) {
    if (order.is_sent) return 'sent'
    if (order.outcome === 'expired_open') return 'expired_open'
    if (order.outcome === 'expired_progress') return 'expired_progress'
    if (order.outcome === 'approved') return 'closed'
    return order.status
}
